<template>
  <div class="d-flex flex-column daytime-advice-sheet-page">
    <div class="d-flex daytime-advice-sheet-content">
      <v-container
        fluid
        class="pa-2 daytime-advice-sheet"
      >
        <v-row class="pa-4 pt-0 pb-0 daytime-advice-sheet-row">
          <v-col
            cols="7"
            class="pa-4 pt-0"
            style="height: 100%;"
          >
            <!--// チャット画面 -->
            <chat
              v-if="daytimeAdviceSheet.id != null"
              ref="chat"
              :message-disabled="finished"
              :chat-id="parseInt($route.params.id)"
              :department-type="daytimeAdviceSheet.departmentType"
              :complaint="daytimeAdviceSheet.complaint || ''"
              log-type="daytimeAdvice"
              :coupon-name="daytimeAdviceSheet.couponName"
              :coupon-names="daytimeAdviceSheet.couponNames"
              @after-sending-chat="reloadDaytimeAdviceSheet"
            />
          </v-col>
          <v-col
            cols="5"
            class="pt-0"
          >
            <v-row
              v-if="notStartedYet"
              class="pa-0 align-center justify-center"
            >
              <v-col
                cols="6"
                sm="6"
                md="12"
              >
                <div style="background-color:#FFEEF1; display:flex; align-items:center; padding:6px; gap:4px; margin-bottom: 16px;">
                  <v-icon
                    size="16"
                    style="color:#D72E4B;"
                  >
                    mdi-alert-circle-outline
                  </v-icon>
                  <span style="font-size:12px; color:#D72E4B;">次の助産師に引き継ぐ場合、「未対応」のまま「担当終了」を押下（「対応中」は「相談を終える」を押下）️</span>
                </div>
              </v-col>
            </v-row>
            <daytime-advice-sheet-body
              class="sheet-body-top-safe-area"
              :editing="editing"
            />
            <v-row>
              <v-col>
                <p class="text-md-center pink--text">
                  ※ 運営からのお知らせ ※
                </p>
                <p
                  style="white-space: pre-wrap; overflow-wrap: anywhere; word-break: break-word; line-height: 25px"
                  v-html="daytimeAdviceReferenceContent"
                />
              </v-col>
            </v-row>
            <daytime-advice-images />
          </v-col>
        </v-row>
      </v-container>
      <daytime-advice-sheet-sidebar
        v-if="daytimeAdviceSheet.id != null"
        ref="sidebar"
        class="flex-grow-0 flex-shrink-0 d-none d-sm-flex"
      />
    </div>
    <daytime-advice-action-bar :settled="isBottomBarStatusSettled">
      <template v-if="editing">
        <v-btn
          color="#33B5B4"
          class="font-weight-bold"
          theme="dark"
          @click="saveSheet()"
        >
          保存する
        </v-btn>
        <v-btn
          variant="outlined"
          color="#33B5B4"
          @click="cancel()"
        >
          キャンセル
        </v-btn>
      </template>
      <v-btn
        v-else
        :color="notStartedYet ? 'grey' : '#33B5B4'"
        class="font-weight-bold"
        theme="dark"
        @click="notStartedYet ? disableEditing() : startEditing()"
      >
        編集する
      </v-btn>
      <v-btn
        v-if="!finished"
        variant="outlined"
        :color="isActiveFinishButton() ? 'pink' : 'grey'"
        class="font-weight-bold"
        @click="clickFinishButton()"
      >
        相談を終える
      </v-btn>
      <risk-assessment-bar-action
        :editable="riskAssessmentStatus?.editable ?? true"
        :editable-until-label="riskAssessmentEditableUntilLabel"
        @open="openRiskAssessment()"
      />
      <high-risk-report-bar-action
        :reportable="highRiskReportStatus.reportable"
        :risk-assessment-required="highRiskReportStatus.riskAssessmentRequired"
        @open="openHighRiskReport()"
      />
    </daytime-advice-action-bar>

    <!-- リスクアセスメント入力。入力途中の内容は本インスタンスが保持するため、
         画面滞在中は unmount させない。 -->
    <risk-assessment-launcher
      v-if="daytimeAdviceSheet.id != null"
      ref="riskAssessmentLauncher"
      consultable-type="DaytimeAdviceSheet"
      :consultable-id="String(daytimeAdviceSheet.id)"
      @status-changed="riskAssessmentStatus = $event"
      @settled-changed="riskAssessmentSettled = $event"
      @report-requested="openHighRiskReport($event)"
    />

    <!-- ハイリスク疑いの報告。サンクス画面からの導線（@report-requested）もここへ繋ぐ。 -->
    <high-risk-report-launcher
      v-if="daytimeAdviceSheet.id != null"
      ref="highRiskReportLauncher"
      consultable-type="DaytimeAdviceSheet"
      :consultable-id="String(daytimeAdviceSheet.id)"
      @status-changed="highRiskReportStatus = $event"
      @settled-changed="highRiskReportSettled = $event"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Chat from "./shared/Chat.vue";
import DaytimeAdviceSheetBody from "./shared/DaytimeAdviceSheetBody.vue";
import DaytimeAdviceImages from "./shared/DaytimeAdviceImages.vue";
import DaytimeAdviceActionBar from "./shared/DaytimeAdviceActionBar.vue";
import { DaytimeAdviceSheetSidebar } from "@/vue/widgets/daytime-advice-sheet-sidebar";
import { RiskAssessmentLauncher } from "@/vue/widgets/risk-assessment";
import RiskAssessmentBarAction from "./shared/RiskAssessmentBarAction.vue";
import { HighRiskReportLauncher } from "@/vue/widgets/high-risk-report";
import HighRiskReportBarAction from "./shared/HighRiskReportBarAction.vue";
import { useBottomBarStatusSettled } from "../features/bottom-bar-status";

export default {
  name: "DaytimeAdviceSheet",
  components: {
    Chat,
    DaytimeAdviceSheetBody,
    DaytimeAdviceImages,
    DaytimeAdviceActionBar,
    DaytimeAdviceSheetSidebar,
    RiskAssessmentLauncher,
    RiskAssessmentBarAction,
    HighRiskReportLauncher,
    HighRiskReportBarAction
  },
  setup() {
    return useBottomBarStatusSettled();
  },
  data: () => ({
    editing: false,
    // RiskAssessmentLauncher が GET /new から受け取った起動可否・修正可能期限。
    riskAssessmentStatus: null,
    highRiskReportStatus: { reportable: false, riskAssessmentAvailable: false, riskAssessmentRequired: false },
    isSaved: false
  }),
  computed: {
    riskAssessmentEditableUntilLabel: function () {
      return this.riskAssessmentStatus?.editableUntilLabel ?? "";
    },
    ...mapGetters([
      "daytimeAdviceSheet",
      "daytimeAdviceReferenceInfo",
    ]),
    finished: function (){
      return this.daytimeAdviceSheet.finished;
    },
    noAdvice: function (){
      return this.daytimeAdviceSheet.noAdvice;
    },
    notStartedYet: function() {
      return this.daytimeAdviceSheet.status == "not_started_yet";
    },
    inProcess: function() {
      return this.daytimeAdviceSheet.status == "in_process";
    },
    daytimeAdviceSheetUserId: function() {
      return this.daytimeAdviceSheet.userId;
    },
    daytimeAdviceReferenceContent: function() {
      return this.daytimeAdviceReferenceInfo.content || "";
    }
  },
  watch: {
    "$route" () {
      this.clearData();
      this.fetchData();
    },
    daytimeAdviceSheetUserId: {
      handler: "findUser",
      immediate: true
    }
  },
  created() {
    this.fetchData();
  },
  unmounted() {
    this.clearData();
  },
  methods: {
    // 担当・操作可能期間・学童以上の判定は Launcher 側が GET /new で行い、
    // 起動できない場合はスナックバーを出すため、ボタン側での活性判定は行わない。
    openRiskAssessment: function () {
      this.$refs.riskAssessmentLauncher.open();
    },
    // ボトムバーからは根拠アセスメントを指定せず、サーバーが返す直近の完了分を使う。
    // リスクアセスメント完了直後のサンクス画面からは riskAssessmentId 付きで呼ばれる。
    openHighRiskReport: function (payload) {
      this.$refs.highRiskReportLauncher?.open(payload ?? {});
    },
    ...mapActions(["updateDaytimeAdviceSheet", "findUser", "resetUser"]),
    fetchData: function() {
      this.$store.dispatch("clearDaytimeAdviceSheet");

      this.$store.dispatch("fetchDaytimeAdviceSheet", {
        id: this.$route.params.id
      });
      this.$store.dispatch("fetchDaytimeAdviceReferenceInfo", {
        id: this.$route.params.id
      });
    },
    findUser: function() {
      if (this.daytimeAdviceSheetUserId != null) {
        this.$store.dispatch("findUser", {
          userId: this.daytimeAdviceSheetUserId
        });
      }
    },
    clearData: function(){
      this.$store.dispatch("clearDaytimeAdviceSheet");
      this.resetUser();

      // 編集状態など画面を制御しているフラグをリセット
      this.editing = false;
      this.isSaved = false;
    },
    startEditing: function() {
      this.editing = true;
    },
    saveSheet: function() {
      this.updateDaytimeAdviceSheet(this.daytimeAdviceSheet).then(() => {
        // TODO: エラーハンドリング
        this.editing = false;
        this.isSaved = true;
      });
    },
    endEditing: function() {
      this.editing = false;
    },
    finishAdvice: function() {
      if(confirm("相談を終了します。よろしいですか？")) {
        this.$store.dispatch("finishDaytimeAdviceSheet", {
          id: this.$route.params.id
        }).then(() => {
          this.$router.push({ path: "/daytime_advices/room" });
        });
      }
    },
    cancel: function(){
      this.endEditing();
      // 入力データをリセットする
      this.$store.dispatch("fetchDaytimeAdviceSheet", {
        id: this.$route.params.id
      });
      this.findUser({ userId: this.daytimeAdviceSheetUserId });
    },
    disableEditing: function() {
      alert("今の状態では、カルテを編集できません。次の対応をお願いします。\n・メッセージを送付");
    },
    clickFinishButton: function() {
      if (this.notStartedYet) {
        // 未対応
        alert("今の状態では、「相談を終える」を押せません。以下の対応をお願いします。\n\n・次の助産師に担当してもらう場合、もしくは営業時間終了で対応不可の場合、「担当終了」\n・ご自身で担当する場合、チャットを送付");
      } else if (this.inProcess && this.editing) {
        // 対応中 && カルテ編集中
        alert("今の状態では、「相談を終える」を押せません。以下の対応をお願いします。\n\n・カルテを保存");
      } else if (this.inProcess && this.noAdvice === null) {
        // 対応中 + 相談未選択
        alert("今の状態では、「相談を終える」を押せません。以下の対応をお願いします。\n\n・「相談あり」「相談なし」どちらか必ず選択し、保存");
      } else {
        // 対応中 + 相談選択済み + カルテを保存ボタン押下後
        this.finishAdvice();
      }
    },
    isActiveFinishButton: function() {
      // 対応中 + 相談選択済み + 編集中ではない
      // MEMO: noAdviceに何かしら入っていれば保存された状態と判断する
      return this.inProcess && this.noAdvice !== null && !this.editing;
    },
    reloadDaytimeAdviceSheet: function() {
      const refreshAssignedList = () => {
        this.$store.dispatch("fetchAssignedAdviceSheets").catch(() => {});
        this.$store.dispatch("fetchPoolingCount");
      };

      if (this.notStartedYet){
        // ステータスが変更されているので再取得する
        this.$store.dispatch("fetchDaytimeAdviceSheet", {
          id: this.$route.params.id
        }).finally(() => {
          refreshAssignedList();
        });

        return;
      }

      refreshAssignedList();
    },
  }
};
</script>

<style lang="scss" scoped>
// ナビゲーション・タブ(担当/検索)は常に画面上部に固定表示させるため、
// このページ自体はビューポート内(ナビ・タブの高さを除いた分)に高さを収め、
// はみ出す分は内部の各領域(v-row/チャット/サイドバー)でスクロールさせる
.daytime-advice-sheet-page {
  height: calc(100vh - 96px); /* 96px = compact TopMenu(48px) + v-tabs(48px) */
  overflow: hidden;
}

// ボトムバーの上に来る領域（メインカラム + サイドバー）
// DaytimeAdviceActionBarはposition: fixedで画面下端に固定されるため、
// その高さ分(64px)を確保して本文がバーの下に隠れないようにする
.daytime-advice-sheet-content {
  flex: 1 1 auto;
  min-height: 0;
  padding-bottom: 64px;
}

.daytime-advice-sheet {
  height: 100%;
  display: flex;
  flex-direction: column;
  // 画像が多いと内容の最小幅が膨らみ、サイドバーが押し縮められるため
  min-width: 0;
}

.daytime-advice-sheet-row {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  // v-rowはデフォルトで負のmargin-topを持つ(ガター用)ため、pt-0で打ち消すpaddingが
  // 無いとこの行自体が親(.daytime-advice-sheet、overflow: hiddenの.daytime-advice-sheet-pageの
  // 内側)の上端より上にはみ出し、その分が恒久的にクリップされ「上部が見切れる」原因になる。
  // 上方向のみ0にリセットして食い込みを防ぐ(左右のガター・下方向はそのまま維持)。
  margin-top: 0;
}

/*
 * タブ直下で右カラム先頭が見切れるケースを防ぐため、
 * 本文コンポーネントに常時わずかな上余白を確保する。
 */
.sheet-body-top-safe-area {
  padding-top: 8px;
}
</style>
